import type { Autosave } from "../lib/useAutosave";

type Props = { autosave: Pick<Autosave<unknown>, "state" | "failed" | "message" | "retry"> };

/** One live region for autosave: a quiet "Saved", or an error with Retry. */
export function SaveStatus({ autosave }: Props) {
  const failed = Object.keys(autosave.failed).length > 0;
  return (
    <div className="mt-3 min-h-11 text-[13px]">
      <p role="status" aria-live="polite" className="text-muted">
        {autosave.state === "saved" ? "Saved" : autosave.state === "saving" ? "Saving…" : ""}
      </p>
      {failed ? (
        <div role="alert" className="flex items-center justify-between gap-3 text-danger">
          <span>{autosave.message ?? "Your answer didn't save."}</span>
          <button type="button" className="btn btn-secondary min-h-11 px-4 text-[13px]" onClick={autosave.retry}>
            Retry
          </button>
        </div>
      ) : null}
    </div>
  );
}
